import { createContext } from "react";

export type FeatureFlagContextValues = {
  /**
   * Check whether a feature flag is enabled for the current organization.
   * Returns false if no organization context or the flag doesn't exist.
   */
  isEnabled: (flagKey: string) => boolean;

  /**
   * Check whether all flags in a group are enabled.
   */
  isGroupEnabled: (group: string) => boolean;

  /**
   * The raw resolved flags map (key -> enabled).
   */
  flags: Map<string, { enabled: boolean; group: string }>;

  loading: boolean;
};

export const FeatureFlagContext =
  createContext<FeatureFlagContextValues | null>(null);
